import React, { useContext, useState } from "react";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import {
  Button,
  Input,
  Menu,
  MenuButton,
  MenuItem,
  Dropdown,
  Modal,
  ModalDialog,
  ModalClose,
  Stack,
  CircularProgress,
  Typography,
} from "@mui/joy";
import { NavLink } from "react-router-dom";
import { Icon } from "@iconify/react";
import styled from "styled-components";
import { AppContext } from "../../contexts/AppContext";
import { createClient } from "../../services/clients";
import { isMobile } from "react-device-detect";

const Label = styled.label`
  font-size: 18px;
  font-weight: 500;
  color: var(--main-font-color);
  margin-bottom: 10px;
`;

const SidebarWrapper = styled.div`
  width: 250px;
  position: fixed;
  background-color: var(--sidebar-bg);
  border: 1px solid var(--sidebar-border-color);
  box-sizing: content-box;

  height: auto;
`;

const Sidebar = styled.div`
  width: 250px;
  overflow: hidden auto;
  height: 100vh;
  padding: 20px 16px 8px 16px;
  display: flex;
  flex-direction: column;
`;

const SidebarItems = styled.div`
  margin-top: 20px;
`;

const SidebarItem = styled(NavLink)`
  display: flex;
  flex-direction: row;
  align-items: center;
  font-size: 18px;
  padding: 13px 5px 13px 10px;
  border-radius: 8px;
  cursor: pointer;
  color: var(--sidebar-item-color) !important;

  &.active {
    background-color: var(--sidebar-active-item-bg);
  }

  &.active  * {
    color: var(--sidebar-active-item-color) !important;
  }

  &:hover:not(.active) {
    background-color: var(--sidebar-active-item-bg);
  }
`;

const SidebarItemText = styled.span`
  font-size: 16px;
  font-weight: 500;
  color: var(--sidebar-item-color);
  padding-left: 10px;
`;

const SidebarItemIcon = styled(Icon)`
  font-size: 18px;
  color: var(--sidebar-item-color);
`;

export const ClientSidebar = ({
  brand,
  items,
  activeColor,
  onClosed = () => { },
}) => {
  const { clients, addClient, selectedClient, setSelectedClient, hasPlatformFeature, theme, setTheme } = useContext(
    AppContext
  );
  const activeUser = useSelector((state) => state.users.activeUser);
  const [open, setOpen] = useState(false);
  const [saving, setSaving] = useState(false);
  const [sidebarShow, setSidebarShow] = useState(
    isMobile ? "-translate-x-full" : ""
  );
  const { pathname } = useLocation();

  console.log("!!! SIDEBAR SELECTED CLIENT: ", selectedClient)


  return (
    <SidebarWrapper
      className={
        "block top-0 bottom-0 w-64 bg-white left-0 absolute flex-row flex-nowrap md:z-10 z-9999 transition-all duration-300 ease-in-out transform " +
        sidebarShow
      }
      style={{}}
    >
      <button
        className="flex items-center justify-center cursor-pointer text-blueGray-700 w-6 h-10 border-l-0 border-r border-t border-b border-solid border-blueGray-100 text-xl leading-none bg-white rounded-r border border-solid border-transparent absolute top-1/2 -right-24-px focus:outline-none z-9998"
        onClick={() => {
          console.log("!!! HERE: ", sidebarShow);
          if (sidebarShow === "") {
            onClosed(true);
            setSidebarShow("-translate-x-full");
          } else {
            onClosed(false);
            setSidebarShow("");
          }
        }}
        style={{
          backgroundColor: "var(--sidebar-active-item-bg)",
          color: "var(--sidebar-active-item-color)",
        }}
      >
        <i className="fas fa-ellipsis-v"></i>
      </button>
      <Sidebar>
        {/*
        <img
          style={{
            height: "100px",
            width: "100px",
            alignSelf: "center",
            marginBottom: "20px",
          }}
          src={require("assets/img/awlogo.png")}
          alt="Agentwire"
        />
        */}
        {!activeUser?.user_type.match(/client/) ? (
          <>
            <Dropdown>
              <MenuButton style={{ color: "var(--main-font-color)", fontSize: "16px", border: "none" }}>
                {selectedClient?.name}
                <Icon icon="lucide:chevron-down" />
              </MenuButton>
              <Menu
                color="neutral"
                style={{ maxHeight: "500px", overflow: "auto" }}
              >
                <MenuItem key="header">
                  <div style={{ width: "100%", height: "100%" }}>
                    Choose Client
                  </div>
                </MenuItem>
                {clients.map((client, index) => (
                  <MenuItem key={client.id}>
                    <div
                      style={{ width: "100%", height: "100%" }}
                      onClick={() => {
                        setSelectedClient(clients[index]);
                      }}
                    >
                      {client.name}
                    </div>
                  </MenuItem>
                ))}
                <MenuItem
                  style={{ borderTop: "1px solid rgba(99, 107, 116, 0.2)" }}
                  key="new"
                >
                  <div
                    style={{
                      width: "100%",
                      height: "100%",
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "center",
                    }}
                    onClick={() => {
                      setOpen(true);
                    }}
                  >
                    <SidebarItemIcon icon="lucide:plus-circle" />
                    <SidebarItemText>New Client</SidebarItemText>
                  </div>
                </MenuItem>
              </Menu>
            </Dropdown>
          </>
        ) : (
          <Label>{selectedClient?.name}</Label>
        )}

        <SidebarItems style={{ flexGrow: 0 }}>
          {hasPlatformFeature("dashboard") &&
            <SidebarItem to="dashboard">
              <span>
                <SidebarItemIcon icon="lucide:layout-dashboard" />
              </span>
              <SidebarItemText>Dashboard</SidebarItemText>
            </SidebarItem>
          }
          {hasPlatformFeature("agents") &&
            <SidebarItem to="agents">
              <span>
                <SidebarItemIcon icon="lucide:bot" />
              </span>
              <SidebarItemText>Agents</SidebarItemText>
            </SidebarItem>
          }
          {false && hasPlatformFeature("media") &&
            <SidebarItem to="media">
              <span>
                <SidebarItemIcon icon="lucide:files" />
              </span>
              <SidebarItemText>Data</SidebarItemText>
            </SidebarItem>
          }
          {hasPlatformFeature("train") &&
            <SidebarItem to="train">
              <span>
                <SidebarItemIcon icon="lucide:graduation-cap" />
              </span>
              <SidebarItemText>Agent Training</SidebarItemText>
            </SidebarItem>
          }
          {hasPlatformFeature("data") &&
            <SidebarItem to="data">
              <span>
                <SidebarItemIcon icon="lucide:folders" />
              </span>
              <SidebarItemText>Data</SidebarItemText>
            </SidebarItem>
          }
          {hasPlatformFeature("supporting content") &&
            <SidebarItem to="supporting-content">
              <span>
                <SidebarItemIcon icon="lucide:folders" />
              </span>
              <SidebarItemText>Generated Content</SidebarItemText>
            </SidebarItem>
          }
          {hasPlatformFeature("chat") &&
            <SidebarItem to="chat">
              <span>
                <SidebarItemIcon icon="lucide:message-circle" />
              </span>
              <SidebarItemText>Chat</SidebarItemText>
            </SidebarItem>
          }
          {hasPlatformFeature("live events") &&
            <SidebarItem to="live-events" className={pathname.includes("live-event") ? "active" : ""}>
              <span>
                <SidebarItemIcon icon="lucide:video" />
              </span>
              <SidebarItemText>Live Events</SidebarItemText>
            </SidebarItem>
          }
          {hasPlatformFeature("messages") &&
            <SidebarItem to="messages">
              <span>
                <SidebarItemIcon icon="lucide:inbox" />
              </span>
              <SidebarItemText>Messages</SidebarItemText>
            </SidebarItem>
          }
          {hasPlatformFeature("responses") &&
            <SidebarItem to="responses">
              <span>
                <SidebarItemIcon icon="lucide:file-pen-line" />
              </span>
              <SidebarItemText>Responses</SidebarItemText>
            </SidebarItem>
          }
          {hasPlatformFeature("users") &&
            <SidebarItem to="users">
              <span>
                <SidebarItemIcon icon="lucide:users" />
              </span>
              <SidebarItemText>Users</SidebarItemText>
            </SidebarItem>
          }
          {hasPlatformFeature("events") &&
            <SidebarItem to="events">
              <span>
                <SidebarItemIcon icon="lucide:text" />
              </span>
              <SidebarItemText>Events</SidebarItemText>
            </SidebarItem>
          }
          {hasPlatformFeature("emails") &&
            <SidebarItem to="emails">
              <span>
                <SidebarItemIcon icon="lucide:mail" />
              </span>
              <SidebarItemText>Emails</SidebarItemText>
            </SidebarItem>
          }
          {hasPlatformFeature("usage") &&
            <SidebarItem to="usage">
              <span>
                <SidebarItemIcon icon="lucide:receipt-text" />
              </span>
              <SidebarItemText>Usage</SidebarItemText>
            </SidebarItem>
          }
          {hasPlatformFeature("settings") &&
            <SidebarItem to="settings">
              <span>
                <SidebarItemIcon icon="lucide:sliders" />
              </span>
              <SidebarItemText>Settings</SidebarItemText>
            </SidebarItem>
          }
        </SidebarItems>

        <hr
          style={{
            backgroundColor: "rgba(99, 107, 116, 0.2)",
            borderBottomColor: "rgba(99, 107, 116, 0.2)",
            borderBottomWidth: 1,
            aligntSelf: "stretch",
          }}
        />

        <SidebarItems>
          {!activeUser?.user_type.match(/client/) ? (
            <SidebarItem to="admin">
              <span>
                <SidebarItemIcon icon="lucide:settings" />
              </span>
              <SidebarItemText>Admin</SidebarItemText>
            </SidebarItem>
          ) : null}
          <SidebarItem to="/login?logout=true">
            <span>
              <SidebarItemIcon icon="lucide:log-out" />
            </span>
            <SidebarItemText>Logout</SidebarItemText>
          </SidebarItem>
          <SidebarItem>
            <span>Theme</span>
            <select
              style={{
                border: "1px solid rgba(99, 107, 116, 0.2)",
                borderRadius: "4px",
                padding: "5px",
                fontSize: "14px",
                width: "100px",
                marginLeft: "10px",
              }}
              onChange={(e) => {
                const theme = e.target.value;
                localStorage.setItem("theme", theme);
                setTheme(theme);
              }}
              value={theme}
            >
              <option value="default">Default</option>
              <option value="dark">Dark</option>
            </select>
          </SidebarItem>
        </SidebarItems>
      </Sidebar>
      <Modal open={open} onClose={() => setOpen(false)}>
        <ModalDialog>
          <ModalClose />
          <Typography level="h2">Create new client</Typography>
          <Label style={{ fontSize: "14px", marginBottom: "0px" }}>
            Client Name
          </Label>
          <form
            onSubmit={async (e) => {
              e.preventDefault();
              const formData = new FormData(e.target);
              const formJson = Object.fromEntries(formData.entries());
              setSaving(true);
              const response = await createClient(formJson.name);
              setSaving(false);
              addClient(response);
              setTimeout(() => setSelectedClient(response), 100);
              setOpen(false);
            }}
          >
            <Stack spacing={1}>
              <Input variant="outlined" required name="name" />
              <Button type="submit" disabled={saving}>
                {saving ? (
                  <>
                    <CircularProgress />
                    <span style={{ marginLeft: "5px" }}>Saving</span>
                  </>
                ) : (
                  "Submit"
                )}
              </Button>
              <Button variant="cancel" disabled={saving}>
                Cancel
              </Button>
            </Stack>
          </form>
        </ModalDialog>
      </Modal>
    </SidebarWrapper>
  );
};

export default ClientSidebar;
